import type { AttentionPage, WorkspaceCabinet } from "@wms/domain";
import { api } from "./client";
import { portalApi } from "./portal";

export interface AttentionQuery {
  kind?: string | null;
  limit?: number;
  offset?: number;
  /** The first rows of every group (the widget of the desktop). */
  per_kind?: number;
}

/**
 * ТЗ «Рабочие столы» 31.10.2026 (UXW-29): the bases of «Требует внимания». Staff and the client cabinet have their own
 * endpoints and tokens; the answer has the same shape.
 */
export const attentionApi = {
  get(cabinet: WorkspaceCabinet, query: AttentionQuery): Promise<AttentionPage> {
    const params = { ...query, kind: query.kind || undefined } as Record<string, unknown>;
    return cabinet === "portal" ? portalApi.get<AttentionPage>("/attention", params) : api.get<AttentionPage>("/dashboard/attention", params);
  },
};
